import { motion, MotionProps } from "framer-motion";
import { FC, PropsWithChildren } from "react";
import {
  DEFAULT_MOTION_PROPS,
  slideInAndScaleFromBottomMotion,
} from "../../constants/motions.constants";
import { useProfileAppContext } from "../../stores";

interface IMotion extends MotionProps {
  className?: string;
}

const Motion: FC<PropsWithChildren<IMotion>> = ({
  children,
  className,
  variants = slideInAndScaleFromBottomMotion,
  ...motionProps
}) => {
  const {
    state: { prefersReducedMotion },
  } = useProfileAppContext();

  return (
    <motion.div
      {...DEFAULT_MOTION_PROPS}
      {...motionProps}
      className={className}
      {...(!prefersReducedMotion && { variants })}
    >
      {children}
    </motion.div>
  );
};

export default Motion;
